import { Navigate, type RouteObject } from "react-router-dom";
import { NotFound } from "./NotFound";

export const publicRoutes: RouteObject[] = [
  { path: "/", element: <Navigate to="/app" /> },
  { path: "*", element: <NotFound /> },
];
